/* Accessoire-productpagina (sections/pf-pdp-acc.liquid), ontwerp 15-10.
   - Galerij (pijlen, teller, thumbnails, swipen) en vaste bestelbalk: zelfde gedrag als de iPhone-pagina v3.
   - "Past op jouw <model>": het opgeslagen toestel (localStorage "pf-device", zoals de categoriepagina's en de modelkiezer).
     Staat het toestel niet in de lijst, dan zeggen we dat eerlijk ("Past niet op jouw …").
   - Maak 'm compleet, Hoesje + glas samen, Andere keuzes en Meer voor je model: uit de bestaande categoriefeeds (?view=pf-acc-data),
     via assets/pf-category-core.js. Alleen strikt verkoopbare producten (available, voorraad bijgehouden, voorraad > 0) en bij
     modelgebonden producten alleen wat op het exacte model past. Niets gevonden = regel of blok weg.
   - "Nu bereikbaar" alleen binnen de openingstijden (Amsterdamse tijd, uit de thema-instellingen via het adviespaneel). */
(() => {
  const root = document.querySelector('[data-pfa]');
  if (!root) return;
  const $ = (s, r) => (r || root).querySelector(s), $$ = (s, r) => [...(r || root).querySelectorAll(s)];
  const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };
  let T = {}; try { T = JSON.parse(($('[data-pfa-i18n]') || {}).textContent || '{}'); } catch (e) { T = {}; }
  const t = (k, vars) => String(T[k] || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (m, v) => (vars && vars[v] != null ? vars[v] : ''));
  const money = cents => new Intl.NumberFormat('nl-NL', {style: 'currency', currency: 'EUR', minimumFractionDigits: cents % 100 ? 2 : 0}).format(cents / 100);
  const cat = root.dataset.catKey, curId = String(root.dataset.productId), curPrice = Number(root.dataset.price), curMs = root.dataset.ms === '1';
  const models = (root.dataset.models || '').split(',').map(s => s.trim()).filter(Boolean);
  // ?pf_model= (modelknop op deze pagina) gaat voor het opgeslagen toestel, alleen als dit product op dat model past.
  const device = (() => { try { const q = new URLSearchParams(location.search).get('pf_model'); if (q && models.includes(q)) return q; return localStorage.getItem('pf-device') || ''; } catch (e) { return ''; } })();
  const fitsDevice = device && models.includes(device);
  const groupUrls = new Set((root.dataset.group || '').split(',').map(s => s.split(':')[0]).filter(Boolean).map(h => '/products/' + h));
  // Korte naam zoals bovenaan de pagina: merk + lijn, zonder "Apple iPhone …" en "- with Microban".
  const shortName = r => { const s = String(r.title || '').replace(/\s*-?\s*with Microban.*$/i, '').replace(/\s+(Apple\s+)?iPhone\b.*$/i, '').replace(/\s+\+\s*MS\b/, ' + MagSafe').trim(); return s.split(' ').length >= 2 ? s : (r.name || r.title); };
  const model = fitsDevice ? device : models[0] || (models.length ? '' : device);

  /* ── Galerij ── */
  const track = $('[data-pfp-track]');
  if (track) {
    const slides = $$('[data-pfp-slide]', track), count = $('[data-pfp-count]'), dots = $$('.pfp-gal__dots i'), thumbs = $$('[data-pfp-thumb]');
    const index = () => Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
    const go = i => { const n = (i + slides.length) % slides.length; track.scrollTo({left: n * track.clientWidth, behavior: 'smooth'}); };
    let raf = 0;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => {
      const i = index();
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      dots.forEach((d, n) => d.classList.toggle('is-on', n === i));
      thumbs.forEach((b, n) => { b.classList.toggle('is-on', n === i); b.setAttribute('aria-pressed', String(n === i)); });
    }); }, {passive: true});
    const prev = $('[data-pfp-prev]'), next = $('[data-pfp-next]');
    if (prev) prev.addEventListener('click', () => go(index() - 1));
    if (next) next.addEventListener('click', () => go(index() + 1));
    thumbs.forEach(b => b.addEventListener('click', () => go(Number(b.dataset.pfpThumb))));
    track.addEventListener('keydown', e => { if (e.key === 'ArrowRight') { e.preventDefault(); go(index() + 1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); go(index() - 1); } });
  }

  /* ── Desktop: beide kolommen even hoog (zoals de iPhone-pagina v3). De foto groeit mee (vanaf de CSS-hoogte, max. 640 px, tot 1200 px
     breed max. 700 px) tot foto's + kenmerken + uitklapblokken zo hoog zijn als het koopblok; zo geen gat onder de uitklapblokken. ── */
  const galCol = $('.pfa-gal-col'), galBox = $('.pfp-gal'), rowsBox = $('.pfa-rows'), buyBox = $('[data-pfp-buy]'), wide = window.matchMedia('(min-width: 1024px)');
  function balance() {
    if (!galCol || !galBox || !rowsBox || !buyBox) return;
    galBox.style.removeProperty('--pfa-gal-h');
    if (!wide.matches) return;
    const base = galBox.getBoundingClientRect().height;
    const gap = parseFloat(getComputedStyle(galCol.parentElement).rowGap) || 0;
    const rest = galCol.getBoundingClientRect().height - base + gap + rowsBox.getBoundingClientRect().height;
    const max = window.innerWidth >= 1200 ? 640 : 700;
    galBox.style.setProperty('--pfa-gal-h', Math.round(Math.max(base, Math.min(max, buyBox.getBoundingClientRect().height - rest))) + 'px');
  }
  balance(); window.addEventListener('resize', balance); wide.addEventListener('change', balance); window.addEventListener('load', balance);
  if ('ResizeObserver' in window && buyBox) new ResizeObserver(() => balance()).observe(buyBox);

  /* ── Vaste bestelbalk zodra de grote knop uit beeld is ── */
  const bar = document.querySelector('[data-pfp-bar]'), cta = $('[data-pfp-cta]');
  if (bar && cta && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      const show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.hidden = !show; bar.setAttribute('aria-hidden', String(!show));
      const b = bar.querySelector('button'); if (b) b.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('pfp-bar-on', show);
    }).observe(cta);
  }

  /* ── Modelkeuze (dropdown): voorkiezen op het model van de klant; kiezen gaat naar dat model (zelfde of ander product) ── */
  const msel = $('[data-pfa-model-select]');
  if (msel) {
    const opts = [...msel.options], own = opts.find(o => o.dataset.model === device);
    if (own && own.hasAttribute('data-own')) msel.value = own.value;
    else if (own) { own.textContent = own.dataset.model + ' · ' + t('yours'); }
    // Ander model: data-cands = "handle@rang,…" (snippets/pf-pdp-acc-models, beste eerst). Neem de eerste die verkoopbaar is
    // (templates/product.pf-stock: beschikbaar én voorraad bijgehouden én aantal > 0);
    // rang 'other' = andere kleurfamilie, dan meldt de doelpagina dat (pf_kleur=anders). Fout of niets op voorraad: value.
    let go = 0;
    msel.addEventListener('change', async () => {
      const o = msel.options[msel.selectedIndex]; if (!o || !o.value) return;
      const cands = (o.dataset.cands || '').split(',').map(s => s.trim().split('@')).filter(c => c[0]).slice(0, 12);
      if (o.hasAttribute('data-own') || !cands.length) { location.href = o.value; return; }
      const me = ++go; msel.setAttribute('aria-busy', 'true');
      let dest = o.value;
      try {
        const res = await Promise.all(cands.map(([h]) => fetch('/products/' + encodeURIComponent(h) + '?view=pf-stock', {headers: {Accept: 'application/json'}})
          .then(r => (r.ok ? r.json() : null)).catch(() => null)));
        const i = res.findIndex(p => p && p.sellable === true);
        if (i >= 0) {
          const [h, rank] = cands[i];
          dest = '/products/' + h + '?pf_model=' + encodeURIComponent(o.dataset.model || '') + (rank === 'other' ? '&pf_kleur=anders' : '');
        }
      } catch (e) { dest = o.value; }
      if (me !== go) return;
      msel.removeAttribute('aria-busy');
      location.href = dest;
    });
  }
  // Doelpagina van de modelkeuze: de gekozen kleur bestond niet (op voorraad) voor dit model.
  try { if (new URLSearchParams(location.search).get('pf_kleur') === 'anders') { const cn = $('[data-pfa-color-note]'); if (cn) cn.hidden = false; } } catch (e) { /* geen melding */ }

  /* ── Past op jouw model ── */
  const fit = $('[data-pfa-fit]');
  if (models.length && device) {
    if (fitsDevice) {
      if (fit) { $('[data-pfa-fit-title]', fit).textContent = t('fitsYour', {model: device}); $('[data-pfa-fit-sub]', fit).textContent = t('madeFor'); }
      $$('[data-pfa-model]').forEach(a => a.classList.toggle('is-mine', a.dataset.pfaModel === device));
      const chip = $('[data-pfa-fitchip]'); if (chip && chip.lastChild) chip.lastChild.textContent = t('fitsOn', {model: device});
      const crumb = $('[data-pfa-crumb-model]'); if (crumb) { crumb.textContent = device; crumb.href = crumb.href.replace(/pf_model=[^&]*/, 'pf_model=' + encodeURIComponent(device)); }
    } else if (fit) {
      fit.classList.add('is-mismatch');
      $('[data-pfa-fit-title]', fit).textContent = t('notFitYour', {model: device});
      $('[data-pfa-fit-sub]', fit).textContent = t('notFitSub');
    }
  }

  /* ── Bereikbaarheid ── */
  function renderStatus() {
    const st = window.pfAdvice && typeof window.pfAdvice.status === 'function' ? window.pfAdvice.status() : null;
    const out = $('[data-pfa-status]'), dot = $('[data-pfa-dot]'); if (!out || st === null) return;
    let cfg = {}; try { cfg = JSON.parse((document.querySelector('[data-advice-config]') || {}).textContent || '{}'); } catch (e) { cfg = {}; }
    const hours = String(cfg.hours || '').split(/\n|;/).map(s => s.trim()).filter(Boolean).join(', ');
    if (st) { dot.hidden = false; out.textContent = t('open') + (hours ? ' · ' + hours : ''); return; }
    dot.hidden = true;
    const next = nextOpen(cfg.hours || '');
    if (next) out.textContent = next;
  }
  // Volgende opening uit dezelfde openingstijden ("ma t/m za 10:00–19:00"), in Amsterdamse tijd.
  function nextOpen(text) {
    const DAYS = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'], rules = [];
    String(text).split(/\n|;/).forEach(l => {
      const m = l.trim().toLowerCase().match(/^(ma|di|wo|do|vr|za|zo)[a-z]*\.?(?:\s*(?:-|–|t\/m)\s*(ma|di|wo|do|vr|za|zo)[a-z]*\.?)?\s*:?\s*(\d{1,2})[:.](\d{2})\s*(?:-|–|tot)\s*(\d{1,2})[:.](\d{2})/);
      if (m) rules.push({a: DAYS.indexOf(m[1]), b: m[2] ? DAYS.indexOf(m[2]) : DAYS.indexOf(m[1]), from: +m[3] * 60 + +m[4], label: m[3].padStart(2, '0') + ':' + m[4]});
    });
    if (!rules.length) return '';
    const parts = {}; new Intl.DateTimeFormat('en-GB', {timeZone: 'Europe/Amsterdam', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'}).formatToParts(new Date()).forEach(p => { parts[p.type] = p.value; });
    const day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(parts.weekday), min = +parts.hour * 60 + +parts.minute;
    const inDay = (r, d) => r.a <= r.b ? d >= r.a && d <= r.b : d >= r.a || d <= r.b;
    const names = String(T.days || '').split(',');
    for (let k = 0; k < 8; k++) {
      const d = (day + k) % 7, r = rules.find(x => inDay(x, d) && (k > 0 || min < x.from));
      if (!r) continue;
      if (k === 0) return t('today', {time: r.label});
      if (k === 1) return t('tomorrow', {time: r.label});
      const n = names[d] || ''; return t('onDay', {day: n.charAt(0).toUpperCase() + n.slice(1), time: r.label});
    }
    return '';
  }
  window.addEventListener('load', renderStatus);

  /* ── Toevoegen ("+", "Voeg beide toe"): /cart/add.js, daarna de winkelwagenlade ── */
  const status = $('[data-pfa-xs-status]'), pending = new Set();
  root.addEventListener('click', async e => {
    const btn = e.target.closest('[data-pfp-add]'); if (!btn || !btn.dataset.pfpAdd) return;
    e.preventDefault();
    const ids = btn.dataset.pfpAdd.split(',').map(s => s.trim()).filter(Boolean), key = ids.join(',');
    if (pending.has(key)) return; pending.add(key); btn.disabled = true; btn.classList.add('is-busy');
    try {
      let props = null; try { props = btn.dataset.pfpProps ? JSON.parse(btn.dataset.pfpProps) : null; } catch (err) { props = null; }
      const items = ids.map(id => { const it = {id: Number(id), quantity: 1}; if (props && props[id]) it.properties = props[id]; return it; });
      const res = await fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items})});
      if (!res.ok) throw new Error('add');
      const json = await res.json().catch(() => null);
      btn.classList.add('is-added'); if (status) status.hidden = true;
      document.dispatchEvent(new CustomEvent('cart:open', {detail: {opener: btn, added: json && Array.isArray(json.items) ? json.items.map(l => l.key) : []}}));
    } catch (err) {
      if (status) { status.hidden = false; status.textContent = t('addFail'); }
    } finally { pending.delete(key); btn.disabled = false; btn.classList.remove('is-busy'); }
  });

  /* ── Feeds (zelfde bron en cache als de winkelwagenlade: sessionStorage "pf-cart-feed:<pad>", 10 minuten) ── */
  const handleize = s => String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  async function feed(path, handle) {
    const key = 'pf-cart-feed:' + path;
    try { const s = JSON.parse(sessionStorage.getItem(key) || 'null'); if (s && Date.now() - s.t < 600000) return s.p; } catch (e) { /* geen cache */ }
    let out = [];
    for (let n = 1, pages = 1; n <= pages && n <= 8; n++) {
      const u = new URL(path, location.origin); u.searchParams.set('view', 'pf-acc-data'); u.searchParams.set('page', n);
      const res = await fetch(u.pathname + u.search, {credentials: 'same-origin'}); if (res.status === 404) break; if (!res.ok) throw new Error('HTTP ' + res.status);
      const m = (await res.text()).match(/data-pf-category-data>([\s\S]*?)<\/script>/); if (!m) break;
      const j = JSON.parse(m[1]); if (j.handle !== handle) break;
      out = out.concat(j.products); pages = j.pages;
    }
    try { sessionStorage.setItem(key, JSON.stringify({t: Date.now(), p: out})); } catch (e) { /* vol */ }
    return out;
  }
  const rowsOf = (core, handle, products) => core.hydrate(handle, products).rows.filter(r => r.cartVariant && String(r.id) !== curId);
  const isLens = r => /camera|lens/i.test(r.title);
  const byRank = (a, b) => a.rank - b.rank;
  // Kabel die bij het model hoort: iPhone 15 en nieuwer (en 16e, Air) USB-C, ouder Lightning (Apple-specificatie).
  const usbcModel = m => /^iPhone (1[5-9]|Air|16e)/.test(m);

  function xsRow(r, label, fitModel) {
    const row = el('div', 'pfp-xs__row');
    const img = el('a', 'pfp-xs__img'); img.href = r.url; if (r.image) { const i = el('img'); i.src = r.image; i.alt = ''; i.width = 44; i.height = 44; i.loading = 'lazy'; img.append(i); }
    const txt = el('span', 'pfp-xs__txt'); const a = el('a', '', shortName(r)); a.href = r.url;
    const small = el('small', fitModel ? 'is-fit' : ''); if (fitModel) small.innerHTML = root.querySelector('[data-pfa-xs]').dataset.check || ''; small.append(document.createTextNode(fitModel ? t('fitsOn', {model: fitModel}) : label)); txt.append(a, small);
    const btn = el('button', 'pfp-xs__add'); btn.type = 'button'; btn.dataset.pfpAdd = r.cartVariant; if (fitModel) btn.dataset.pfpProps = JSON.stringify({[r.cartVariant]: {'Geschikt voor': fitModel}});
    btn.setAttribute('aria-label', t('addAria', {name: r.name || r.title})); btn.innerHTML = root.querySelector('[data-pfa-xs]').dataset.plus || '+';
    row.append(img, txt, el('span', 'pfp-xs__price', money(r.price)), btn);
    return row;
  }
  function otherCard(r, label, cls) {
    const a = el('a', 'pfa-oc'); a.href = r.url;
    const im = el('span', 'pfa-oc__img'); if (r.image) { const i = el('img'); i.src = r.image; i.alt = ''; i.width = 72; i.height = 72; i.loading = 'lazy'; im.append(i); }
    const b = el('span', 'pfa-oc__body'); b.append(el('small', 'pfa-oc__kind ' + (cls || ''), label), el('strong', '', shortName(r)));
    const p = el('span', 'pfa-oc__price', money(r.price)); const d = r.price - curPrice;
    if (d) p.append(el('span', 'pfa-oc__diff', (d > 0 ? '+ ' : '− ') + money(Math.abs(d))));
    b.append(p); a.append(im, b); return a;
  }
  function moreCard(r, kind, fitModel) {
    const c = el('div', 'pfa-mc');
    const im = el('a', 'pfa-mc__img'); im.href = r.url; if (r.image) { const i = el('img'); i.src = r.image; i.alt = ''; i.width = 64; i.height = 76; i.loading = 'lazy'; im.append(i); }
    const b = el('div', 'pfa-mc__body'); const a = el('a', '', shortName(r)); a.href = r.url;
    b.append(el('span', 'pfa-mc__kind', kind), a);
    if (fitModel) { const f = el('span', 'pfa-mc__fit'); f.innerHTML = root.querySelector('[data-pfa-xs]').dataset.check || ''; f.append(document.createTextNode(t('fitsOn', {model: fitModel}))); b.append(f); }
    b.append(el('span', 'pfa-mc__price', money(r.price)));
    const btn = el('button', 'pfp-xs__add'); btn.type = 'button'; btn.dataset.pfpAdd = r.cartVariant; if (fitModel) btn.dataset.pfpProps = JSON.stringify({[r.cartVariant]: {'Geschikt voor': fitModel}});
    btn.setAttribute('aria-label', t('addAria', {name: r.name || r.title})); btn.innerHTML = root.querySelector('[data-pfa-xs]').dataset.plus || '+';
    c.append(im, b, btn); return c;
  }

  async function recommend() {
    const core = window.PrimeFoneCategory; if (!core) return;
    const D = root.dataset;
    const needCases = !!model, src = {};
    try {
      const jobs = [
        feed(D.glassUrl, 'screenprotectors').then(p => { src.glass = rowsOf(core, 'screenprotectors', p); }),
        feed(D.chargersUrl, 'laders').then(p => { src.chargers = rowsOf(core, 'laders', p); }),
        feed(D.powerbanksUrl, 'powerbanks').then(p => { src.powerbanks = rowsOf(core, 'powerbanks', p); }),
        feed(D.cablesUrl, 'kabels').then(p => { src.cables = rowsOf(core, 'kabels', p); })
      ];
      if (needCases) jobs.push(feed(D.casesUrl.replace(/\/$/, '') + '/' + handleize(model + ' Hoesjes'), 'telefoon-hoesjes').then(p => { src.cases = rowsOf(core, 'telefoon-hoesjes', p); }));
      if (cat === 'case' && !needCases) jobs.push(feed(D.casesUrl, 'telefoon-hoesjes').then(p => { src.cases = rowsOf(core, 'telefoon-hoesjes', p); }));
      await Promise.all(jobs);
    } catch (e) { return; }
    // Past op het gekozen model; zonder opgeslagen toestel op een van de modellen van dit product.
    const fitModels = fitsDevice ? [device] : models.length ? models : (model ? [model] : []);
    const fitsM = r => fitModels.some(m => r.model.includes(m));
    const fitOf = r => fitModels.find(m => r.model.includes(m)) || model;
    const glassFit = (src.glass || []).filter(r => fitsM(r) && !isLens(r)).sort(byRank)[0];
    // 19-10 (Moniem): hoesje zonder passend schermglas → algemeen product "Screenprotector voor jouw iPhone" ("Voor toestel", geen link).
    const glassAny = cat === 'case' && !glassFit && model ? (() => { try { const n = document.querySelector('[data-pf-glass-fallback]'); return n ? JSON.parse(n.textContent) : null; } catch (e) { return null; } })() : null;
    if (glassAny) glassAny.name = 'Screenprotector voor je ' + model;
    const lensFit = (src.glass || []).filter(r => fitsM(r) && isLens(r)).sort(byRank)[0];
    const caseFit = (src.cases || []).filter(fitsM).sort(byRank)[0];
    const wireless = (src.chargers || []).filter(r => (r.kind || []).includes('Draadloos')).sort(byRank)[0];
    const wall = (src.chargers || []).filter(r => (r.kind || []).includes('Stopcontact')).sort(byRank)[0];
    const pb = (src.powerbanks || []).sort(byRank)[0];
    const cableFor = m => (src.cables || []).filter(r => m ? (usbcModel(m) ? (r.conn || []).includes('USB-C ↔ USB-C') : (r.conn || []).includes('Lightning')) : (r.conn || []).includes('USB-C ↔ USB-C')).sort(byRank)[0];

    // Maak 'm compleet: per categorie logisch; regels zonder passend product vallen weg.
    const plan = {
      case: [[glassFit || glassAny, glassFit ? T.glass : 'We sturen de passende versie mee', glassFit && fitOf(glassFit)], [lensFit, T.lens, lensFit && fitOf(lensFit)], [wireless || wall, wireless ? T.wireless : T.adapter, '']],
      glass: [[caseFit, T.case, caseFit && fitOf(caseFit)], [lensFit, T.lens, lensFit && fitOf(lensFit)], [wireless || wall, wireless ? T.wireless : T.adapter, '']],
      cable: [[wall, T.adapter, ''], [pb, T.powerbank, ''], [caseFit, T.case, caseFit && fitOf(caseFit)]],
      adapter: [[cableFor(model), T.cable, ''], [pb, T.powerbank, ''], [caseFit, T.case, caseFit && fitOf(caseFit)]],
      powerbank: [[cableFor(model), T.cable, ''], [wall, T.adapter, ''], [caseFit, T.case, caseFit && fitOf(caseFit)]]
    }[cat] || [];
    const rows = plan.filter(p => p[0]).map(([r, label, fm]) => {
      const row = xsRow(r, label, fm);
      if (r === glassAny) { row.querySelectorAll('a').forEach(a => a.removeAttribute('href')); row.querySelector('.pfp-xs__txt a').textContent = 'Screenprotector voor je ' + model; row.querySelector('[data-pfp-add]').dataset.pfpProps = JSON.stringify({[r.cartVariant]: {'Voor toestel': model}}); }
      return row;
    });
    const xs = $('[data-pfa-xs]');
    if (xs && rows.length) { $('[data-pfa-xs-dyn]', xs).replaceChildren(...rows); xs.hidden = false; }
    // Hoesje + glas samen: alleen op een hoesjespagina met een passende screenprotector.
    // Combideal (21-10): met een screenprotector uit de collectie geldt de automatische korting (data-combi, centen);
    // dan oude prijs doorgestreept en de nieuwe prijs. Het algemene vervangende glas valt buiten die collectie: alleen de optelsom.
    const both = $('[data-pfa-both]'), curVar = D.variantId;
    const gb = glassFit || glassAny;
    if (both && cat === 'case' && gb && curVar && !$('.pfa-cta__btn').disabled) {
      const btn = $('[data-pfp-add]', both);
      btn.dataset.pfpAdd = curVar + ',' + gb.cartVariant;
      const gm = glassFit ? fitOf(glassFit) : model; btn.dataset.pfpProps = JSON.stringify(gm ? {[curVar]: {'Geschikt voor': gm}, [gb.cartVariant]: glassFit ? {'Geschikt voor': gm} : {'Voor toestel': gm}} : {});
      const sum = curPrice + gb.price, off = glassFit ? Math.min(Number(D.combi) || 0, gb.price) : 0;
      $('[data-pfa-both-price]', both).textContent = money(sum - off);
      const was = $('[data-pfa-both-was]', both); if (was) { was.textContent = money(sum); was.hidden = !off; }
      $$('[data-pfa-combi-deal]', both).forEach(n => { n.hidden = !off; });
      const gp = $('[data-pfa-combi-glass]', both); if (gp && gb.image) { const i = el('img'); i.src = gb.image; i.alt = ''; i.width = 56; i.height = 56; i.loading = 'lazy'; gp.replaceChildren(i); }
      both.classList.toggle('is-deal', off > 0);
      both.hidden = false;
    }

    // Andere keuzes: dezelfde categorie, hetzelfde model (bij modelgebonden producten), max. 3 naast dit product.
    const sameCat = {case: src.cases, glass: (src.glass || []).filter(r => !isLens(r)), cable: src.cables, adapter: src.chargers, powerbank: src.powerbanks}[cat] || [];
    const others = sameCat.filter(r => (models.length ? fitsM(r) : true) && !groupUrls.has(r.url.split('?')[0])).sort(byRank).slice(0, 3);
    const og = $('[data-pfa-others-grid]');
    if (og && others.length) {
      og.append(...others.map(r => {
        const props = r.props || [], types = (r.type || []).map(x => String(x).toLowerCase());
        if (props.includes('MagSafe') && !curMs) return otherCard(r, T.magsafe, 'is-purple');
        if (r.price < curPrice) return otherCard(r, T.cheaper, 'is-green');
        if (types.some(x => /wallet|bookcase|pasjes/.test(x))) return otherCard(r, T.cards, 'is-purple');
        if (props.includes('Transparant')) return otherCard(r, T.clear, '');
        return otherCard(r, T.other, '');
      }));
      $('[data-pfa-others]').hidden = false;
    }

    // Meer voor je model: screenprotector, powerbank, adapter en kabel die passen.
    const more = $('[data-pfa-more]');
    if (more && model) {
      const cards = [[glassFit, T.glass, glassFit && fitOf(glassFit)], [pb, T.powerbank, ''], [wall, T.adapter, ''], [cableFor(model), T.cable, '']].filter(c => c[0] && String(c[0].id) !== curId).map(([r, k, fm]) => moreCard(r, k, fm));
      if (cards.length) {
        const grid = $('[data-pfa-more-grid]'); grid.prepend(...cards);
        $('[data-pfa-more-eyebrow]').textContent = t('moreEyebrow', {model}); $('[data-pfa-more-title]').textContent = t('moreTitle', {model});
        $('[data-pfa-navy-title]').textContent = t('navyTitle', {model});
        more.hidden = false;
      }
    }
  }
  const start = () => { if ('requestIdleCallback' in window) requestIdleCallback(recommend, {timeout: 1500}); else setTimeout(recommend, 300); };
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
})();
